import axios from "axios";
import { configUrl } from "config.js";

const createEnquiry = async (payload) => {
    let response = await axios.post(
        `${configUrl.AssessmentServer}/api/Enquiry/Create`,
        payload,
    );

    return response.data;
};

export default createEnquiry;